import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <p className="font-display text-8xl font-bold leading-none text-brass-400">404</p>
      <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-field-50">
        Page not found
      </h1>
      <p className="mt-2 text-sm text-field-400">
        That page does not exist — or it moved while you were on the waiver wire.
      </p>
      <Link to="/" className="btn-primary mt-6">
        Back to the home page
      </Link>
    </div>
  );
}
